import './GatewayCard.scss';

import classNames from 'classnames';
import { When } from 'react-if';

import { Card, Flex } from 'antd';
import React, { PropsWithChildren } from 'react';

export interface GatewayCardProps {
    className?: string;
    id?: string;
	pre?: string | React.ReactNode;
    title: string;
}

export const GatewayCard: React.FC<PropsWithChildren<GatewayCardProps>> = ({
	children,
	className,
	id,
	pre,
	title
}) =>
	<Card
		className={ classNames('gateway-card', className) }
		id={ id }>
		<When condition={ Boolean(pre) }>
			{ pre }
		</When>
		<Flex
			gap={ 16 }
			justify='space-between'
			vertical>
			<div className='h1'>{ title }</div>
			{ children }
		</Flex>
	</Card>;
